import { render, staticRenderFns } from "./afterPurchaseOrder.vue?vue&type=template&id=5bf33034&scoped=true&"
import script from "./afterPurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./afterPurchaseOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf33034",
  null
  
)

component.options.__file = "afterPurchaseOrder.vue"
export default component.exports